<template>
  <div class="graph">
    <canvas ref="canvas" width="100%"></canvas>
  </div>
</template>

<script>
// eslint-disable-next-line
import { Chart, registerables } from 'chart.js';
import { mergeDeep } from '../utils';

Chart.register(...registerables);

const arbitaryLine = {
  id: 'arbitaryLine',
  beforeDraw(chart, args, options) {
    const {
      ctx,
      chartArea: {
        top,
        height,
      },
      scales: {
        x,
      },
    } = chart;

    ctx.save();
    ctx.strokeStyle = options.arbitaryLineColor;
    ctx.strokeRect(x.getPixelForValue(options.xPosition), top, 1, height);
    ctx.restore();

    ctx.font = 'bold 10px Inter';
    ctx.fillStyle = options.arbitaryLineColor;
    ctx.fillText('LIVE', (x.getPixelForValue(options.xPosition) - 9), 20);
  },
};

export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      default: 'line',
    },
    showYLabels: {
      type: Boolean,
      default: false,
    },
    showXLabels: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    graphData() {
      if (!this.mounted) {
        return null;
      }

      const {
        data,
        // eslint-disable-next-line
        key,
      } = this;

      return data;
    },
  },
  methods: {
    update() {
      if (this.graph) {
        this.graph.update();
      }
    },
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.key += 1;
      },
    },
    options: {
      deep: true,
      immediate: true,
      handler() {
        this.graphOptions = mergeDeep(this.graphOptions, this.options);
        if (this.graph) {
          this.graph.options = this.graphOptions;
          this.graph.update();
        }
      },
    },
    graphData: {
      immediate: true,
      handler(data) {
        if (data === null) {
          return;
        }

        const { type, graphOptions: options } = this;
        if (!this.graph) {
          this.graph = new Chart(this.$refs.canvas, {
            type,
            data,
            options,
            plugins: [arbitaryLine],
          });
        } else {
          this.graph.data = data;
          this.graph.update();
        }
      },
    },
  },
  data() {
    return {
      graph: null,
      mounted: false,
      key: 0,
      resizeTimeout: null,
      graphOptions: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          intersect: false,
          mode: 'index',
        },
        plugins: {
          legend: {
            display: false,
          },
        },
        layout: {
          padding: {
            left: -20,
            right: 0,
            top: 0,
            bottom: 0,
          },
        },
        scales: {
          y: {
            grid: {
              borderWidth: 0,
              color: 'rgb(244,246,254, 0)', // Make configurable
            },
            ticks: {
              padding: 20,
              display: false,
              beginAtZero: true,
              precision: 0,
              tickLength: 100,
            },
          },
          x: {
            grid: {
              lineWidth: 0,
              drawTicks: false,
              borderWidth: 0,
            },
            ticks: {
              padding: 10,
            },
          },
        },
      },
    };
  },
  mounted() {
    this.mounted = true;
  },
  beforeDestroy() {
    clearTimeout(this.resizeTimeout);
  },
};
</script>

<style lang="scss" scoped>
.graph {
  height: 100%;
  position: relative;
  padding: 0 16px;
  max-width: 100%;
}
canvas {
  width: 100% !important;
  max-height: 40vh;
}
</style>
